import React from 'react';
import { Download } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../../components/ui/table';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';

const fmtDate = (dateStr) => {
  if (!dateStr) return '';
  const parts = dateStr.split('-');
  if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
  return dateStr;
};

export const ReportsTab = ({ reportDates, setReportDates, reportData, generateReport, downloadReport }) => {
  return (
    <div data-testid="reports-content">
      <div className="bg-[#121816] p-6 rounded-lg border border-[#D4AF37]/30 mb-6">
        <h3 className="font-serif text-lg font-semibold text-[#E8E3D9] mb-4">Generate Report</h3>
        <div className="flex flex-wrap gap-4 items-end">
          <div><Label>Start Date</Label><Input type="date" value={reportDates.start} onChange={(e) => setReportDates(prev => ({ ...prev, start: e.target.value }))} className="mt-1" /></div>
          <div><Label>End Date</Label><Input type="date" value={reportDates.end} onChange={(e) => setReportDates(prev => ({ ...prev, end: e.target.value }))} className="mt-1" /></div>
          <Button onClick={generateReport} className="bg-[#D4AF37] hover:bg-[#E5C766]">Generate Report</Button>
          {reportData && <Button variant="outline" onClick={downloadReport}><Download size={16} className="mr-2" /> Download CSV</Button>}
        </div>
      </div>
      {reportData && (
        <div className="space-y-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="bg-[#121816] p-4 rounded-lg border border-[#D4AF37]/30"><p className="text-sm text-[#8E9A95]">Total Bookings</p><p className="text-2xl font-semibold">{reportData.summary.total_bookings}</p></div>
            <div className="bg-[#121816] p-4 rounded-lg border border-[#D4AF37]/30"><p className="text-sm text-[#8E9A95]">Total Amount</p><p className="text-2xl font-semibold">₹{reportData.summary.total_booking_amount?.toLocaleString()}</p></div>
            <div className="bg-[#121816] p-4 rounded-lg border border-[#D4AF37]/30"><p className="text-sm text-[#8E9A95]">Collection</p><p className="text-2xl font-semibold text-green-600">₹{reportData.summary.total_collection?.toLocaleString()}</p></div>
            <div className="bg-[#121816] p-4 rounded-lg border border-[#D4AF37]/30"><p className="text-sm text-[#8E9A95]">Balance</p><p className="text-2xl font-semibold text-[#D4AF37]">₹{reportData.summary.total_balance?.toLocaleString()}</p></div>
          </div>
          <div className="bg-[#121816] rounded-lg border border-[#D4AF37]/30 overflow-hidden">
            <div className="overflow-x-auto">
              <Table>
                <TableHeader><TableRow><TableHead>Guest</TableHead><TableHead>Contact</TableHead><TableHead>Rooms</TableHead><TableHead>Members</TableHead><TableHead>Check-in</TableHead><TableHead>Check-out</TableHead><TableHead>Booked On</TableHead><TableHead>Total</TableHead><TableHead>Advance</TableHead><TableHead>Coll. 1</TableHead><TableHead>Coll. 2</TableHead><TableHead>Restaurant</TableHead><TableHead>Balance</TableHead><TableHead>Status</TableHead></TableRow></TableHeader>
                <TableBody>
                  {reportData.bookings.map(booking => {
                    const roomsDisplay = (booking.room_names && booking.room_names.length > 0) ? booking.room_names.join(', ') : (booking.room_name || booking.room_type);
                    return (
                      <TableRow key={booking.id}>
                        <TableCell className="font-medium">{booking.guest_name}</TableCell>
                        <TableCell className="text-[#8E9A95]">{booking.phone || '-'}</TableCell>
                        <TableCell className="capitalize">{roomsDisplay}</TableCell>
                        <TableCell className="text-center">{booking.num_guests}</TableCell>
                        <TableCell>{fmtDate(booking.check_in_date)}</TableCell>
                        <TableCell>{fmtDate(booking.check_out_date)}</TableCell>
                        <TableCell className="text-[#8E9A95]">{booking.created_at ? fmtDate(booking.created_at) : '-'}</TableCell>
                        <TableCell>₹{(booking.total_price || 0).toLocaleString()}</TableCell>
                        <TableCell className="text-green-600">₹{(booking.advance_amount || 0).toLocaleString()}</TableCell>
                        <TableCell className="text-blue-600">₹{(booking.checkin_collection || 0).toLocaleString()}</TableCell>
                        <TableCell className="text-blue-600">₹{(booking.checkin_collection_2 || 0).toLocaleString()}</TableCell>
                        <TableCell className="text-purple-600">₹{(booking.restaurant_bill || 0).toLocaleString()}</TableCell>
                        <TableCell className="text-[#D4AF37] font-medium">₹{(booking.balance || 0).toLocaleString()}</TableCell>
                        <TableCell><span className={`status-badge status-${booking.status}`}>{booking.status?.replace('_', ' ')}</span></TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
